<template lang="pug">
.history-article-default
  .form-section
    .history-container
      .history-label(:class="color") Version
      div {{ dataOriginal.version }}
    .history-container
      .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
      shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
      shNameUser(v-else :dni="dataOriginal.updatedBy")
    .history-container(v-if="dataOriginal.priceUnit")
      .history-label Price Unit
      div {{ money(dataOriginal.priceUnit) }}
    .history-container(v-if="dataOriginal.priceThree")
      .history-label Price Three
      div {{ money(dataOriginal.priceThree) }}
    .history-container(v-if="dataOriginal.priceWholesaler")
      .history-label Price Wholesaler
      div {{ money(dataOriginal.priceWholesaler) }}
    .history-container(v-if="dataOriginal.priceSale")
      .history-label Price Sale
      div {{ money(dataOriginal.priceSale) }}
    .history-container(v-if="dataOriginal.sizes.length")
      .history-label Sizes
      div.uppercase {{ sizes }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryUser',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  },

  computed: {
    sizes () {
      return this.arrayToString(this.dataOriginal.sizes)
    }
  }
}
</script>

<style lang="stylus">
.history-article-default
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/articleDefault/History.vue